// IMAGE GALLERY SECTION
class ProductGallery extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (this.querySelectorAll(`.swiper-slide`)) {
      this.querySelectorAll(`.gallery-top`).forEach((item) => {
        const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
          direction: "horizontal",
          slidesPerView: 5,
          spaceBetween: 10,
          // mousewheel: true,
          freeMode: true,
          loop: true,
          breakpoints: {
            0: {
              slidesPerView: 5,
              spaceBetween: 4,
              direction: "horizontal",
            },
            600: {
              spaceBetween: 10,
              slidesPerView: 5,
            },
          },
        })
        const sliderImages = new Swiper(item, {
          direction: "horizontal",
          slidesPerView: 1,
          spaceBetween: 3,
          speed: 1000,
          loop: true,
          mousewheel: false,
          grabCursor: true,
          allowTouchMove: true,
          thumbs: {
            swiper: sliderThumbs,
          },
          navigation: {
            nextEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild,
            prevEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          pagination: {
            el: item.querySelector(".swiper-pagination"),
            clickable: true,
            type: "progressbar",
          },
          scrollbar: {
            el: item.firstElementChild.nextElementSibling,
          },
          breakpoints: {
            0: {
              direction: "horizontal",
              mousewheel: false,
              allowTouchMove: true,
            },
            769: {
              allowTouchMove: true,
            },
          },
        })

        const event = new Event("productJsLoaded")
        window.dispatchEvent(event)
      })
    }
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector("input")
    this.changeEvent = new Event("change", { bubbles: true })

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)))
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }
}

window.addEventListener("load", () => {
  customElements.define("product-gallery", ProductGallery)
  customElements.define("quantity-input", QuantityInput)

  function detailsCustomSlideToggle() {
    if (document.querySelectorAll(".deatils-slide-animation").length > 0) {
      //reset prevent default details
      document.querySelectorAll(".deatils-slide-animation").forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault()
        })
      })

      document.querySelectorAll(".deatils-slide-animation summary").forEach((summary) => {
        let contentHeight = summary.nextElementSibling.offsetHeight

        if (summary.parentNode.open) {
          summary.parentNode.setAttribute("open", true)
          //remove preven default by click
          summary.nextElementSibling.addEventListener("click", (evn) => {
            evn.stopPropagation()
          })

          summary.nextElementSibling.style.height = contentHeight + "px"
          summary.parentNode.classList.add("closing")
        }

        summary.addEventListener("click", function (event) {
          if (!summary.parentNode.classList.contains("closing") && !summary.parentNode.open) {
            summary.parentNode.setAttribute("open", true)
            //remove preven default by click
            summary.nextElementSibling.addEventListener("click", (evn) => {
              evn.stopPropagation()
            })
            //get height by click
            contentHeight = summary.nextElementSibling.offsetHeight
            summary.nextElementSibling.style.height = "0px"

            setTimeout(() => {
              if (window.jQuery) {
                $(summary)
                  .next()
                  .animate({ height: contentHeight + "px" }, 100)
              } else {
                summary.nextElementSibling.style.height = contentHeight + "px"
              }

              summary.nextElementSibling.removeAttribute("style")
              summary.parentNode.classList.add("closing")
            }, 60)
          } else {
            if (window.jQuery) {
              $(summary).next().animate({ height: "0px" }, 50)
            } else {
              summary.nextElementSibling.style.height = "0px"
            }
            summary.parentNode.classList.remove("closing")
            setTimeout(() => {
              summary.nextElementSibling.removeAttribute("style")
              summary.parentNode.removeAttribute("open", true)
            }, 300)
          }
        })
      })
    }
  }
  detailsCustomSlideToggle()
  $(".fancybox").fancybox()
})
